// extracted by mini-css-extract-plugin
export default {"root":"kINb_0TaNLwnpYe2v5QO","btn":"yGfuDHQFAfc1v85fnCQ7"};